import { render, staticRenderFns } from "./TranslationsView.vue?vue&type=template&id=459d003e&scoped=true"
import script from "./TranslationsView.vue?vue&type=script&lang=js"
export * from "./TranslationsView.vue?vue&type=script&lang=js"
import style0 from "./TranslationsView.vue?vue&type=style&index=0&id=459d003e&prod&scoped=true&lang=css"
import style1 from "./TranslationsView.vue?vue&type=style&index=1&id=459d003e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d003e",
  null
  
)

export default component.exports